/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Sector_PlaceholderInputs */

const en_candidate_profile_sector_placeholder = /** @type {(inputs: Candidate_Profile_Sector_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., IT, Finance, Healthcare`)
};

const de_candidate_profile_sector_placeholder = /** @type {(inputs: Candidate_Profile_Sector_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. IT, Finanzen, Gesundheitswesen`)
};

/**
* | output |
* | --- |
* | "e.g., IT, Finance, Healthcare" |
*
* @param {Candidate_Profile_Sector_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_sector_placeholder = /** @type {((inputs?: Candidate_Profile_Sector_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Sector_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_sector_placeholder(inputs)
	return en_candidate_profile_sector_placeholder(inputs)
});